import { render, staticRenderFns } from "./accountDetails.vue?vue&type=template&id=329948a2&"
import script from "./accountDetails.vue?vue&type=script&lang=js&"
export * from "./accountDetails.vue?vue&type=script&lang=js&"
import style0 from "./accountDetails.vue?vue&type=style&index=0&id=329948a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports